var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 18999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 18998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.88 22.46C19.9617 22.46 22.46 19.9617 22.46 16.88C22.46 13.7983 19.9617 11.3 16.88 11.3C13.7982 11.3 11.3 13.7983 11.3 16.88C11.3 19.9617 13.7982 22.46 16.88 22.46Z",
    fill: "#FCAF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88 39.2C24.32 31.76 31.76 25.098 31.76 16.88C31.76 8.662 25.098 2 16.88 2C8.662 2 2 8.662 2 16.88C2 25.098 9.44 31.76 16.88 39.2Z",
    fill: "#FCAF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88 22.46C19.9617 22.46 22.46 19.9617 22.46 16.88C22.46 13.7983 19.9617 11.3 16.88 11.3C13.7982 11.3 11.3 13.7983 11.3 16.88C11.3 19.9617 13.7982 22.46 16.88 22.46Z",
    stroke: "#013380",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88 39.2C24.32 31.76 31.76 25.098 31.76 16.88C31.76 8.662 25.098 2 16.88 2C8.662 2 2 8.662 2 16.88C2 25.098 9.44 31.76 16.88 39.2Z",
    stroke: "#013380",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M16.8798 22.46C19.9616 22.46 22.4598 19.9618 22.4598 16.88C22.4598 13.7983 19.9616 11.3 16.8798 11.3C13.7981 11.3 11.2998 13.7983 11.2998 16.88C11.2998 19.9618 13.7981 22.46 16.8798 22.46Z",
    fill: "#FCAF33",
    stroke: "#013380",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.c33f94737e84fffc599c1ff32284fd07.svg";
export { ForwardRef as ReactComponent };